// Opening or leaving a group of the menu shows it from its first button: the
// menu kept its scroll, so a group opened from low in the list, such as
// Visores Modelo 1, started at the bottom (the owner's request of 2026-10-13).
export const scrollMenuToTop = () => {
    const menu = document.getElementById('menu-container');
    if (menu) {
        menu.scrollTop = 0;
    }
};

// When the page loads on a viewer, the menu opens on its button and, the
// first time it is shown, centres it, so one low in a long group (21 months
// of Modelo 1, the end of Otros) is in sight (the owner's request of
// 2026-10-13). Measured against the menu rather than with scrollIntoView,
// which would also scroll the page under it.
export const scrollMenuToButton = (button) => {
    const menu = document.getElementById('menu-container');
    if (!menu || !button) return;
    const offset = button.getBoundingClientRect().top - menu.getBoundingClientRect().top + menu.scrollTop;
    menu.scrollTop = Math.max(0, offset - (menu.clientHeight - button.offsetHeight) / 2);
};
